module.exports = __webpack_public_path__ + "static/media/cart.b4b37cf1.svg";